import { Chip, Stack } from '@mui/material';
import { formatDateOnly, numberAsKr } from '../Formatters';
import { GuidePriceModel, SubscriptionModel } from '../interfaces';

export const guideVersions = {
  gjeldende: { kind: 'CurrentGuide', title: 'Enkeltanvisning, gjeldende versjon', number: 'Dokumentnummeret til hver anvisning' },
  historisk: { kind: 'HistoricalGuide', title: 'Enkeltanvisning, historisk versjon', number: 'BFS HIST' },
} as const;

export type GuideVersion = keyof typeof guideVersions;

export type ProductKind = 'Subscription' | (typeof guideVersions)[GuideVersion]['kind'];

/** numberAsKr leaves 0 and missing prices blank; a dash says there is none. */
export const kr = (amount?: number | null) => (amount == null ? '–' : (numberAsKr(amount) ?? '0 kr'));

export function priceWithPending(current?: number | null, next?: number | null) {
  if (next == null) return kr(current);
  return `${kr(current)} → ${kr(next)}`;
}

export function SubscriptionStatus({ subscription }: { subscription: SubscriptionModel }) {
  if (!subscription.isSellable) return <Chip size="small" label="Ikke til salgs" />;
  return (
    <Stack direction="row" spacing={0.5} sx={{ display: 'inline-flex' }}>
      <PriceStatus pending={subscription.pendingPriceChange?.timeOfChange} />
      {subscription.isRecommended && <Chip size="small" color="primary" variant="outlined" label="Anbefalt" />}
    </Stack>
  );
}

export function GuideStatus({ guide }: { guide?: GuidePriceModel }) {
  if (!guide) return null;
  return <PriceStatus pending={guide.pendingPriceChange?.timeOfChange} />;
}

function PriceStatus({ pending }: { pending?: string }) {
  if (pending) return <Chip size="small" color="warning" variant="outlined" label={`Ny pris ${formatDateOnly(pending)}`} />;
  return <Chip size="small" color="success" variant="outlined" label="Til salgs" />;
}
